import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  filtersContainer: { display: 'flex', justifyContent: 'space-between' },
  labelContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  labelContentTitle: {
    alignSelf: 'center',
    color: theme.palette.shadows.dark,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  labelSubTitle: {
    color: theme.palette.shadows.light,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  dateRangePickerWrrapper: {
    width: theme.spacing(27.875),
    '& .MuiOutlinedInput-adornedEnd': {
      background: 'none',
    },
  },
}))
